﻿import { DepartmentAutoCompleteDisplay } from "@/components/AutoCompleteDisplay/components/DepartmentAutoCompleteDisplay";
import { apiEndpoints } from "@/helpers";
import { autoCompleteValueType } from "@/propTypes";
import { string } from "prop-types";
import {
  DefaultAutoCompleteDisplay,
  UserAutoCompleteDisplay,
} from "./components";

const AutoCompleteDisplay = ({ url, value }) => {
  switch (url) {
    case apiEndpoints.users.suggestions:
      return <UserAutoCompleteDisplay url={url} value={value} />;
    case apiEndpoints.departments.suggestions:
      return <DepartmentAutoCompleteDisplay url={url} value={value} />;
    default:
      return <DefaultAutoCompleteDisplay url={url} value={value} />;
  }
};

AutoCompleteDisplay.propTypes = {
  url: string.isRequired,
  value: autoCompleteValueType.isRequired,
};

export default AutoCompleteDisplay;
